import { useState } from "react";
import { DropdownMenu, Icon, Typography } from "@/components/atoms";
import { PointsOfInterest } from "@/redux/apis/clientPoi/types";
import { AddEditLocationModal } from "./AddEditLocationModal";
import { RemoveLocationModal } from "./RemoveLocationModal";

interface FavouriteLocationRowMenuProps {
  location: PointsOfInterest;
  accountId?: string;
}

export const FavouriteLocationRowMenu = ({ location, accountId }: FavouriteLocationRowMenuProps) => {
  const [activeModal, setActiveModal] = useState<"edit" | "remove" | null>(null);

  return (
    <>
      <DropdownMenu
        button={
          <DropdownMenu.Button aria-label="Location actions" className="inline-flex items-center justify-center text-neutral-black">
            <Icon name="options" isCustom size="lg" />
          </DropdownMenu.Button>
        }
        isCustomButton
        position="bottom-end"
      >
        <DropdownMenu.Item onClick={() => setActiveModal("edit")} className="w-56">
          <Icon name="Edit2" size="sm" className="mr-2.5 flex-shrink-0 text-primary-dark" />
          <Typography className="text-primary-dark">Edit</Typography>
        </DropdownMenu.Item>
        <DropdownMenu.Item onClick={() => setActiveModal("remove")} className="w-56">
          <Icon name="Trash" size="sm" className="mr-2.5 flex-shrink-0 text-danger" />
          <Typography className="text-danger">Remove</Typography>
        </DropdownMenu.Item>
      </DropdownMenu>

      <AddEditLocationModal
        open={activeModal === "edit"}
        mode="edit"
        location={location}
        accountId={accountId}
        onClose={() => setActiveModal(null)}
      />
      <RemoveLocationModal open={activeModal === "remove"} location={location} accountId={accountId} onClose={() => setActiveModal(null)} />
    </>
  );
};
